import defaultModeTemplate from 'text!./templates/companyname-details-default.html';
import japanModeTemplate from 'text!./templates/companyname-details-JP.html';

export default ['LocaleService', function (LocaleService) {
    var defaultHiddenFields = [];
    var nameConfig = LocaleService.getNameConfig();

    return {
        restrict: 'A',
        template: nameConfig.mode === 'Japan' ? japanModeTemplate : defaultModeTemplate,
        scope: {
            contact: '=', // if this val is changed in view then it changes in the model
            readonly: '=' // if this val is changed in view it DOES NOT change in the model
        },
        controller: ['$scope', function ($scope) {
            $scope.hiddenFields = defaultHiddenFields;
            $scope.isFieldVisible = function (fieldName) {
                var visible = nameConfig.visibleFields.indexOf(fieldName) >= 0;
                var hidden = $scope.hiddenFields.indexOf(fieldName) >= 0;
                return visible && !hidden;
            };
        }]

    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/CompanyNameDetails.js
// module id = 775
// module chunks = 0